import { basicInitialState } from '../../_utils/basicInitialState';
import { TVesselsLocationsState } from './vesselsLocationsModel';

export const vesselsLocationsInitialState: TVesselsLocationsState = {
  ...basicInitialState,
  locationTimer: null,
  locations: null
};
